import React from "react";
import Main from './container/Game';
import "./Styles/main.scss";


function App() {
  return (
    <>
      <Main/>
    </>
  );
}

export default App;



